import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (!token) return <AuthShell title="Invalid link"><p className="text-slate-600">This reset link is invalid. <Link to="/forgot-password" className="text-emerald-800 underline">Request a new one</Link>.</p></AuthShell>;

  return (
    <AuthShell title="Set a new password" footer={<Link to="/login" className="font-semibold text-emerald-800 hover:underline">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <div className="space-y-2">
          <Label htmlFor="pw">New password</Label>
          <Input id="pw" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cpw">Confirm password</Label>
          <Input id="cpw" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full rounded-full bg-emerald-800 py-6 text-white hover:bg-emerald-900">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
        </Button>
      </form>
    </AuthShell>
  );
}
